var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCkFooterTrophy21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h40v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.56 2.974V1.172C30.56.525 30.033 0 29.386 0h-18.75C9.99 0 9.465.525 9.465 1.172v1.817a4.657 4.657 0 0 0-2.368-.645A4.693 4.693 0 0 0 2.409 7.03a9.79 9.79 0 0 0 1.69 5.51c1.881 2.778 4.202 3.5 6.121 4.267a10.603 10.603 0 0 0 6.139 5.977l-.864 5.496h-.17a3.52 3.52 0 0 0-3.516 3.516v5.86h-1.172a1.172 1.172 0 0 0 0 2.343h18.75a1.172 1.172 0 0 0 0-2.344h-1.172v-5.86a3.52 3.52 0 0 0-3.515-3.515h-.17l-.864-5.496a10.604 10.604 0 0 0 6.143-5.988c1.814-.726 4.191-1.45 6.092-4.257a9.79 9.79 0 0 0 1.69-5.509 4.693 4.693 0 0 0-4.688-4.687c-.854 0-1.654.23-2.344.63zM4.752 7.031a2.346 2.346 0 0 1 2.344-2.343A2.346 2.346 0 0 1 9.44 7.03c0 .083.008.163.024.24v5.62c0 .376.02.748.06 1.115l-.068-.027A7.447 7.447 0 0 1 4.753 7.03zm9.4 30.625v-2.343h11.719v2.343h-11.72zm11.719-5.86v1.173h-11.72v-1.172c0-.646.527-1.172 1.173-1.172H24.7c.646 0 1.172.526 1.172 1.172zm-7.23-8.447a10.595 10.595 0 0 0 2.74 0l.775 4.932h-4.29l.776-4.932zm1.37-2.255c-4.523 0-8.203-3.68-8.203-8.203V7.03h16.406v5.86c0 4.523-3.68 8.203-8.203 8.203zM11.81 4.687V2.345h16.406v2.344H11.81zm18.692 9.308c.038-.363.058-.731.058-1.104V7.03a2.347 2.347 0 0 1 2.344-2.343 2.346 2.346 0 0 1 2.344 2.343 7.447 7.447 0 0 1-4.704 6.948l-.042.016z",
    fill: "#121212"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCkFooterTrophy21);
export default __webpack_public_path__ + "static/media/icon-ck-footer-trophy-21.acf0e89b7b75bfee7200dad2238e464c.svg";
export { ForwardRef as ReactComponent };